import * as React from "react";
import { cn } from "lib/utils";
import { useNavigate } from "react-router-dom";
import { useEventTracking } from "hooks/useEventTracking";

export interface ButtonLinkProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  to: string;
  action?: string;
}

const ButtonLink = React.forwardRef<HTMLButtonElement, ButtonLinkProps>(
  ({ className, children, to, action, ...props }, ref) => {
    const navigate = useNavigate();
    const { track } = useEventTracking();

    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          "font-body-s font-light text-foundation-base-darkbase-dark-500 text-[11px] tracking-[var(--body-s-letter-spacing)] leading-[var(--body-s-line-height)] [font-style:var(--body-s-font-style)] hover:underline transition-colors",
          className
        )}
        onClick={(e) => {
          props.onClick?.(e);
          track("button_click", {
            action: action,
          });
          navigate(to);
        }}
        {...props}
      >
        {children}
      </button>
    );
  }
);
ButtonLink.displayName = "ButtonLink";

export { ButtonLink };
